import type { ReactNode } from "react";

import { Section, sectionTitle } from "./section";

/** A section with its title in a narrow left column and the content beside it. */
export const SplitSection = ({
  title,
  aside,
  children,
}: {
  title: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}) => (
  <Section>
    <div className="grid items-start gap-7 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-3">
      <div className="px-4">
        <h2 className={sectionTitle}>{title}</h2>
        {aside ? <div className="mt-[18px]">{aside}</div> : null}
      </div>
      <div className="min-w-0">{children}</div>
    </div>
  </Section>
);
